import React, { useState } from 'react'
import ChevronDown from 'react-feather/dist/icons/chevron-down'
import _kebabCase from 'lodash/kebabCase'
import '../css/Accordion.css'
import CheckIcon from '../icons/check-circle.svg'
// import CheckIcon from '../img/icons/check-circle.svg'
// import { CheckIcon } from 'react-feather'

export default function AccordionCustom ({
  type,
  title,
  content,
  items,
  exemplar1,
  exemplar2,
  exemplar3,
  exemplar4,
  exemplar5,
  exemplar6,
  exemplar7,
  exemplar8,
  exemplar9,
  exemplar10,
  exemplar11,
  exemplar12,
  exemplar13,
  exemplar14,
  exemplar15,
  exemplar16,
  exemplar17,
  exemplar18,
  exemplar19,
  exemplar20,
  exemplar21,
  exemplarExample1,
  exemplarExample2,
  exemplarExample3,
  exemplarExample4,
  exemplarExample5,
  exemplarExample6,
  exemplarExample7,
  exemplarExample8,
  exemplarExample9,
  exemplarExample10,
  exemplarExample11,
  exemplarExample12,
  exemplarExample13,
  exemplarExample14,
  exemplarExample15,
  exemplarExample16,
  exemplarExample17,
  exemplarExample18,
  exemplarExample19,
  exemplarExample20,
  exemplarExample21,
  pyramid,
}) {


  const [ showAccordion, setShowAccordion ] = useState(false)
  const [ isChecked, setIsChecked ] = useState(false)

  // const [ checkboxChecked, SetCheckboxChecked ] = useState(false)

  var checkCounter = 0;

  function toggleAccordion() {
    if (showAccordion === false) {
      setShowAccordion(true);
    } else {
      setShowAccordion(false);
    }
  }

  function checkCheckboxes(event) {
    if (event.target.checked === true) {
      checkCounter = checkCounter + 1;
      checkCounter >= 0 ? setIsChecked(true) : setIsChecked(false);
    } else {
      checkCounter = checkCounter - 1;
      checkCounter >= 0 ? setIsChecked(true) : setIsChecked(false);
    }
  }
  
  return (
    <div
      className={`accordion--item accordion ${showAccordion === true ? ' active' : ''} ${ type === 'selfassesment' && 'accordion--selfassesment'}`}
      key={`accordion-item-${_kebabCase(title) + '-accordion'}`}
      aria-label="Toggle Accordion"
    >
      <button
        onClick={toggleAccordion}
        className={isChecked === true ? 'options-checked' : ''}>
        <span className="accordion__title">{title}</span><span className="accordion__check">
          <CheckIcon />
        </span>
        <span className="accordion__chevron">
          <ChevronDown />
        </span>
      </button>
      
      <div className={'description'}>
        { type === 'cba-framework' ? (
          <>
            <div className="cba-framework__description">
              {content} 
            </div>
            { pyramid && (
              <div className="cba-framework__pyramid">
                { pyramid === 'Does' && (<img src="../img/pyramid-does.svg" alt="Millers Pyramid Does" />) }
                  { pyramid === 'Knows How' && (<img src="../img/pyramid-knows-how.svg" alt="Millers Pyramid Knows How" />) }
                  { pyramid === 'Knows' && (<img src="../img/pyramid-knows.svg" alt="Millers Pyramid Knows" />) }
                  { pyramid === 'Shows' && (<img src="../img/pyramid-shows.svg" alt="Millers Pyramid Shows" />) }
              </div>
            )}
          </>
        ) : <>{content}</>}
        { type !== 'selfassesment' && 
          <div className={'exemplars'}>
            <span className={'exemplars__evidence'}>
              Assesment types
            </span>
            { exemplar1 && (
              <label>
                {exemplar1}
                <input type="checkbox" name={exemplar1} data-pyramid={pyramid} data-category={title} onChange={event => checkCheckboxes(event)}/>
                <span className={'checkmark'}></span>
              </label>
            )}
            { exemplarExample1 && (
              <span>{exemplarExample1}</span>
            )}
            { exemplar2 && (
              <label>
                {exemplar2}
                <input type="checkbox" name={exemplar2} data-pyramid={pyramid} data-category={title} onChange={event => checkCheckboxes(event)} />
                <span className={'checkmark'}></span>
              </label>
            )}
            { exemplarExample2 && (
              <span>{exemplarExample2}</span>
            )}
            { exemplar3 && (
              <label>
                {exemplar3}
                <input type="checkbox" name={exemplar3} data-pyramid={pyramid} data-category={title} onChange={event => checkCheckboxes(event)} />
                <span className={'checkmark'}></span>
              </label>
            )}
            { exemplarExample3 && (
              <span>{exemplarExample3}</span>
            )}
            { exemplar4 && (
              <label>
                {exemplar4}
                <input type="checkbox" name={exemplar4} data-pyramid={pyramid} data-category={title} onChange={event => checkCheckboxes(event)} />
                <span className={'checkmark'}></span>
              </label>
            )}
            { exemplarExample4 && (
              <span>{exemplarExample4}</span>
            )}
            { exemplar5 && (
              <label>
                {exemplar5}
                <input type="checkbox" name={exemplar5} data-pyramid={pyramid} data-category={title} onChange={event => checkCheckboxes(event)} />
                <span className={'checkmark'}></span>
              </label>
            )}
            { exemplarExample5 && (
              <span>{exemplarExample5}</span>
            )}
            { exemplar6 && (
              <label>
                {exemplar6}
                <input type="checkbox" name={exemplar6} data-pyramid={pyramid} data-category={title} onChange={event => checkCheckboxes(event)} />
                <span className={'checkmark'}></span>
              </label>
            )}
            { exemplarExample6 && (
              <span>{exemplarExample6}</span>
            )}
            { exemplar7 && (
              <label>
                {exemplar7}
                <input type="checkbox" name={exemplar7} data-pyramid={pyramid} data-category={title} onChange={event => checkCheckboxes(event)} />
                <span className={'checkmark'}></span>
              </label>
            )}
            { exemplarExample7 && (
              <span>{exemplarExample7}</span>
            )}
            { exemplar8 && (
              <label>
                {exemplar8}
                <input type="checkbox" name={exemplar8} data-pyramid={pyramid} data-category={title} onChange={event => checkCheckboxes(event)} />
                <span className={'checkmark'}></span>
              </label>
            )}
            { exemplarExample8 && (
              <span>{exemplarExample8}</span>
            )}
            { exemplar9 && (
              <label>
                {exemplar9}
                <input type="checkbox" name={exemplar9} data-pyramid={pyramid} data-category={title} onChange={event => checkCheckboxes(event)} />
                <span className={'checkmark'}></span>
              </label>
            )}
            { exemplarExample9 && (
              <span>{exemplarExample9}</span>
            )}
            { exemplar10 && (
              <label>
                {exemplar10}
                <input type="checkbox" name={exemplar10} data-pyramid={pyramid} data-category={title} onChange={event => checkCheckboxes(event)} />
                <span className={'checkmark'}></span>
              </label>
            )}
            { exemplarExample10 && (
              <span>{exemplarExample10}</span>
            )}
            { exemplar11 && (
              <label>
                {exemplar11}
                <input type="checkbox" name={exemplar11} data-pyramid={pyramid} data-category={title} onChange={event => checkCheckboxes(event)} />
                <span className={'checkmark'}></span>
              </label>
            )}
            { exemplarExample11 && (
              <span>{exemplarExample11}</span>
            )}
            { exemplar12 && (
              <label>
                {exemplar12}
                <input type="checkbox" name={exemplar12} data-pyramid={pyramid} data-category={title} onChange={event => checkCheckboxes(event)} />
                <span className={'checkmark'}></span>
              </label>
            )}
            { exemplarExample12 && (
              <span>{exemplarExample12}</span>
            )}
            { exemplar13 && (
              <label>
                {exemplar13}
                <input type="checkbox" name={exemplar13} data-pyramid={pyramid} data-category={title} onChange={event => checkCheckboxes(event)} />
                <span className={'checkmark'}></span>
              </label>
            )}
            { exemplarExample13 && (
              <span>{exemplarExample13}</span>
            )}
            { exemplar14 && (
              <label>
                {exemplar14}
                <input type="checkbox" name={exemplar14} data-pyramid={pyramid} data-category={title} onChange={event => checkCheckboxes(event)} />
                <span className={'checkmark'}></span>
              </label>
            )}
            { exemplarExample14 && (
              <span>{exemplarExample14}</span>
            )}
            { exemplar15 && (
              <label>
                {exemplar15}
                <input type="checkbox" name={exemplar15} data-pyramid={pyramid} data-category={title} onChange={event => checkCheckboxes(event)} />
                <span className={'checkmark'}></span>
              </label>
            )}
            { exemplarExample15 && (
              <span>{exemplarExample15}</span>
            )}
            { exemplar16 && (
              <label>
                {exemplar16}
                <input type="checkbox" name={exemplar16} data-pyramid={pyramid} data-category={title} onChange={event => checkCheckboxes(event)} />
                <span className={'checkmark'}></span>
              </label>
            )}
            { exemplarExample16 && (
              <span>{exemplarExample16}</span>
            )}
            { exemplar17 && (
              <label>
                {exemplar17}
                <input type="checkbox" name={exemplar17} data-pyramid={pyramid} data-category={title} onChange={event => checkCheckboxes(event)} />
                <span className={'checkmark'}></span>
              </label>
            )}
            { exemplarExample17 && (
              <span>{exemplarExample17}</span>
            )}
            { exemplar18 && (
              <label>
                {exemplar18}
                <input type="checkbox" name={exemplar18} data-pyramid={pyramid} data-category={title} onChange={event => checkCheckboxes(event)} />
                <span className={'checkmark'}></span>
              </label>
            )}
            { exemplarExample18 && (
              <span>{exemplarExample18}</span>
            )}
            { exemplar19 && (
              <label>
                {exemplar19}
                <input type="checkbox" name={exemplar19} data-pyramid={pyramid} data-category={title} onChange={event => checkCheckboxes(event)} />
                <span className={'checkmark'}></span>
              </label>
            )}
            { exemplarExample19 && (
              <span>{exemplarExample19}</span>
            )}
            { exemplar20 && (
              <label>
                {exemplar20}
                <input type="checkbox" name={exemplar20} data-pyramid={pyramid} data-category={title} onChange={event => checkCheckboxes(event)} />
                <span className={'checkmark'}></span>
              </label>
            )}
            { exemplarExample20 && (
              <span>{exemplarExample20}</span>
            )}
            { exemplar21 && (
              <label>
                {exemplar21}
                <input type="checkbox" name={exemplar21} data-pyramid={pyramid} data-category={title} onChange={event => checkCheckboxes(event)} />
                <span className={'checkmark'}></span>
              </label>
            )}
            { exemplarExample21 && (
              <span>{exemplarExample21}</span>
            )}
          </div>
        }
        { type === 'selfassesment' && (
          <>
            <span className={'exemplars__evidence'}>
            EVIDENCE OF DELIVERY AND ASSESMENT (MODULE CODE/NAME) - { title }
            </span>
            <div className={'exemplars__evidence-textarea'}>
              <textarea></textarea>
              <span>Please enter evidence separated by a comma ( , )</span>
            </div>
            <div className={'exemplars__evidence-pyramid'}>
              { pyramid && (
                <div className="cba-framework__pyramid">
                  { pyramid === 'Does' && (<img src="../img/pyramid-does.svg" alt="Millers Pyramid Does" />) }
                  { pyramid === 'Knows How' && (<img src="../img/pyramid-knows-how.svg" alt="Millers Pyramid Knows How" />) }
                  { pyramid === 'Knows' && (<img src="../img/pyramid-knows.svg" alt="Millers Pyramid Knows" />) }
                  { pyramid === 'Shows' && (<img src="../img/pyramid-shows.svg" alt="Millers Pyramid Shows" />) }
                </div>
              )}
            </div>
            <div className="accordion__selfassesment-items">
              <span className={'exemplars__evidence'}>
                Assesment types
              </span>
              { items.nodes.map((item, index) => {
                return (
                <label key={index}>
                  {item.instrument}
                  <input type="checkbox" name={item.instrument} 
                  data-pyramid={pyramid} data-category={title} 
                  onChange={event => checkCheckboxes(event)}
                  data-exemplars={JSON.stringify([{exemplar1, exemplar2, exemplar3, exemplar4, exemplar5, exemplar6, exemplar7, exemplar8, exemplar9, exemplar10,exemplar11, exemplar12, exemplar13, exemplar14, exemplar15, exemplar16, exemplar17, exemplar18, exemplar19, exemplar20, exemplar21 }])}
                  />
                  <span className={'checkmark'}></span>
                </label>
                )
              })}
            </div>
          </>
        )} 
      </div>
    </div>
  )
}